import React from "react";
import { useParams } from "react-router-dom";
import { formattedDateTime } from "../../../../../utils";
import { Divider } from "../../../../atoms/divider";
import { useSingleOktaGroupQuery } from "../../../../../store/okta/groupSlice";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import { Table } from "../../../../atoms/table";
import { Skeleton } from "../../../../atoms/skeleton";
import { PAGE_NAME, ROUTE } from "../../../../../constants/constants";

const SingleOktaGroup = () => {
  const pageClassName = "p-singleOktaGroup";
  
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useSingleOktaGroupQuery(id as string);

  const userTableHeader = [
    {
      title: "Serial",
      dataIndex: "id",
      isSortable: false,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      isSortable: false,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      isSortable: false,
    },
    {
      title: "Email",
      dataIndex: "email",
      isSortable: false,
    },
    {
      title: "Status",
      dataIndex: "status",
      isSortable: false,
    },
    {
      title: "Created",
      dataIndex: "created",
      isSortable: false,
    },
  ];

  const appsTableHeader = [
    {
      title: "Serial",
      dataIndex: "id",
      isSortable: false,
    },
    {
      title: "Name",
      dataIndex: "name",
      isSortable: false,
    },
    {
      title: "Status",
      dataIndex: "status",
      isSortable: false,
    },
    {
      title: "Created",
      dataIndex: "created",
      isSortable: false,
    },
  ];

  return (
    <div className={pageClassName}>
      <Breadcrumb />
      <p className={`${pageClassName}__title`}>{PAGE_NAME.OKTA_GROUP_INFO}</p>
      <div className={`${pageClassName}__container`}>
        <div className={`${pageClassName}__container__info`}>
          <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>Name</p>
            <p className={`${pageClassName}__container__item__value`}>
              {data?.result?.name ?? <Skeleton height="small" />}
            </p>
          </div>
          {data?.result?.users?.length !== 0 && (
            <div className={`${pageClassName}__container__item`}>
              <p className={`${pageClassName}__container__item__title`}>
                Number of Users
              </p>
              <p className={`${pageClassName}__container__item__value`}>
                {data?.result?.users?.length ?? <Skeleton height="small" />}
              </p>
            </div>
          )}
          {data?.result?.apps?.length !== 0 && (
            <div className={`${pageClassName}__container__item`}>
              <p className={`${pageClassName}__container__item__title`}>
                Number of Apps
              </p>
              <p className={`${pageClassName}__container__item__value`}>
                {data?.result?.apps?.length ?? <Skeleton height="small" />}
              </p>
            </div>
          )}
          <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>
              Created
            </p>
            <p className={`${pageClassName}__container__item__value`}>
              {data?.result?.created ? (
                formattedDateTime(data?.result?.created)
              ) : (
                <Skeleton height="small" />
              )}
            </p>
          </div>
          <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>
              Last Updated
            </p>
            <p className={`${pageClassName}__container__item__value`}>
              {data?.result?.lastUpdated ? (
                formattedDateTime(data?.result?.lastUpdated)
              ) : (
                <Skeleton height="small" />
              )}
            </p>
          </div>
          <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>Logo</p>
            <img src={data?.result?.logo} alt={data?.result?.label} />
          </div>
        </div>
        {data?.result?.users?.length > 0 && (
          <>
            <Divider />
            <div className={`${pageClassName}__users`}>
              <p className={`${pageClassName}__users__title`}>Users</p>
              <Table
                header={userTableHeader}
                data={data?.result?.users ?? []}
                loading={isLoading}
                firstLoad={isLoading}
                viewURL={ROUTE.OKTA_USER_LIST}
                startIndex={1}
                cursorPointer
              />
            </div>
          </>
        )}
        {data?.result?.apps?.length > 0 && (
          <>
            <Divider />
            <div className={`${pageClassName}__apps`}>
              <p className={`${pageClassName}__apps__title`}>Apps</p>
              <Table
                header={appsTableHeader}
                data={data?.result?.apps ?? []}
                loading={isLoading}
                firstLoad={isLoading}
                viewURL={ROUTE.OKTA_APP_LIST}
                startIndex={1}
                cursorPointer
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default SingleOktaGroup;
